import { useEffect, useState } from "react";
import classes from "./SearchWithDropdown.module.css"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useScreenSize from "../../Hooks/UseScreenSize";
import { useDispatch, useSelector } from "react-redux";
import { urls } from "../../Routes/Urls";
import { getSuggestionsForNormalBooks } from "../../Store/actions/BookAction";
import { removeUnpairedQuotes } from "../../Util";
import { fetchBook, fetchBookCount } from "../../Store/actions/BestSellerBookAction";
import PrimaryButton from "../Buttons/PrimaryButton/PrimaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchengin } from "@fortawesome/free-brands-svg-icons";
import SearchWithDropdownSmall from "./SearchWithDropdownSmall";

const SearchWithDropdown = ({query,setQuery,searchCriteria,setSearchCriteria,searchRecommendations,handleRecommendationClick,handleSearch}) => {
        const {isSmallScreen} = useScreenSize()
    
        const handleInputChange = (e) => {
            setQuery(e.target.value);
        };

        const handleKeyPress = (e) => {
            if(e.key === "Enter"){
                handleSearch()
            } else {
              const disallowedCharacters = ["(", "{", "[","]","}",")"];
              if (disallowedCharacters.includes(e.key)) {
                e.preventDefault();
              }
            }
        } 
      
        const handleInputPaste = (e) => {
          e.preventDefault();
        
          const pastedText = e.clipboardData.getData("text").replace(/[\(\)\{\}\[\]]/g, ""); // Remove disallowed characters
          const input = e.target;
          const selectionStart = input.selectionStart;
          const selectionEnd = input.selectionEnd;
        
          const updatedQuery =
            query.substring(0, selectionStart) + pastedText + query.substring(selectionEnd);
        
          setQuery(updatedQuery);
        };
    
        const [recommendationClicked,setRecommendationClicked] = useState(false);
        const [focus,setFocus] = useState(false);
        const [blurTimeout, setBlurTimeout] = useState(null);
        
        useEffect(() => {
          if (query) {
            const timeout = setTimeout(() => {
            //   fetchPageData();
              getSuggestionsForNormalBooks(query,"title",10)
            },500);
          
             return () => clearTimeout(timeout);
          }
        }, [query,searchCriteria]);
    
          const handleFocus = () => {
            if (blurTimeout) {
              clearTimeout(blurTimeout); 
            }
            setFocus(true);
          };
        
          const handleBlur = () => {
            const timeout = setTimeout(() => setFocus(false),1000);
            setBlurTimeout(timeout);
          };
    
          return (
            (!isSmallScreen ? (<div className={classes.search}>
                    <div className={classes.container}>
                      <div className={classes.searchContainer}>
                        <div className={classes.dropdownContainer}>
                          <select
                              name="searchField"
                              id="searchField"
                              required
                              onChange={(e) => setSearchCriteria(e.target.value)}
                          >
                              <option value="all">All</option>
                              <option value="title">Book Title</option>
                              <option value="author">Author</option>
                              <option value="isbnNo">ISBN Number</option>
                              <option value="sku">SKU</option>
                              {/* <option value="keyword">Keyword</option>
                              <option value="ISBN">ISBN</option> */}
                          </select>
                        </div>
    
                        <input
                            type="text"
                            className={classes.searchInput}
                            placeholder="Search via , Book title, Author"
                            value={query}
                            onChange={handleInputChange}
                            onKeyDown={(e) => handleKeyPress(e)}
                            onFocus={handleFocus}  
                            onBlur={handleBlur} 
                            onPaste={handleInputPaste}
                        />
                        <PrimaryButton className={classes.searchButton} onClick={handleSearch}>
                            Search Now
                        </PrimaryButton>
                      </div>
                      {/* Dropdown with Recommendations */}
                      {searchRecommendations?.length > 0 && focus && (
                        <div className={classes.dropdown}>
                        {searchRecommendations?.slice(0,10).map((recommendation, index) => (
                          <div
                            key={index}
                            className={classes.dropdownItem}
                            onClick={() => handleRecommendationClick(recommendation)}
                          >
                            <FontAwesomeIcon icon={faSearchengin}/>
                            {recommendation}
                          </div>
                        ))}
                        </div>
                      )}
                  </div>
               
                    {/* <SearchBarSmall/> */}
            
            </div>) : (
              <div>
                <div className={classes.search}>
                 <SearchWithDropdownSmall 
                     query={query}
                     setQuery={setQuery}
                      searchRecommendations={searchRecommendations} 
                      handleRecommendationClick={handleRecommendationClick} 
                      handleSearch={handleSearch} 
                      searchCriteria={searchCriteria}
                      setSearchCriteria={setSearchCriteria}
                  /> 
                </div>
              </div>
            ))
        );
    };
    

export default SearchWithDropdown;